import React, { Component } from 'react';
import { connect } from 'react-redux';

import Icon from "@sm/components/custom/Icon";
import Modal from "@sm/components/custom/Modal";
import PromptModal from '@modules/generateReport/PromptModal';
import Spinner from '@sm/components/Spinner';
import Select from '@sm/components/custom/Select';
import Table from '@sm/components/custom/Table';

import * as actions from '@sm/actions';
import { crudActions } from "@sm/services/crudActions";
import { addLogItem } from "@sm/utils/utils";
class WalletInfo extends Component {

  cryptoExternalColumns = [{
    label: 'Currency',
    value: 'currency'
  }, {
    label: 'Blockchain',
    value: 'blockchain'
  }, {
    label: 'Wallet Address',
    value: 'wallet'
  }, {
    label: 'Name',
    value: 'name'
  }, {
    label: 'Submitted by',
    value: 'submittedBy'
  }, {
    label: 'Status',
    value: 'status',
    centerAligned: true
  }, {
    label: 'Date Submitted',
    value: 'date',
    rightAligned: true
  }];

  cryptoInternalColumns = [{
    label: 'Currency',
    value: 'currency'
  }, {
    label: 'Blockchain',
    value: 'blockchain'
  }, {
    label: 'Wallet Address',
    value: 'wallet'
  }, {
    label: 'Date Submitted',
    value: 'date',
    rightAligned: true
  }];

  fiatExternalColumns = [{
    label: 'Currency',
    value: 'currency'
  }, {
    label: 'Bank Name',
    value: 'bankName'
  }, {
    label: 'AccountNumber',
    value: 'accountNumber'
  }, {
    label: 'Routing Number',
    value: 'routingNumber'
  }, {
    label: 'Bank Address',
    value: 'bankAddress',
    centerAligned: true
  }, {
    label: 'Submitted by',
    value: 'submittedBy'
  }, {
    label: 'Status',
    value: 'status',
    centerAligned: true
  }, {
    label: 'Date Submitted',
    value: 'date',
    rightAligned: true
  }];

  fiatInternalColumns = [{
    label: 'Currency',
    value: 'currency'
  }, {
    label: 'Bank Name',
    value: 'bankName'
  }, {
    label: 'AccountNumber',
    value: 'accountNumber'
  }, {
    label: 'Routing Number',
    value: 'routingNumber'
  }, {
    label: 'Bank Address',
    value: 'bankAddress',
    centerAligned: true
  }, {
    label: 'Date Submitted',
    value: 'date',
    rightAligned: true
  }];

  state = {
    cryptoExternalWallets: [],
    cryptoInternalWallets: [],
    fiatExternalWallets: [],
    fiatInternalWallets: [],
    logs: [],
    isLoadingWallet: true,
    showPromptModal: false,
    editableWalletId: null,
    editableWalletIndex: null,
    editableWalletStatus: '',
    editableWalletType: '',
    walletStatuses: [],
    showModal: false,
    modalData: ''
  };

  componentDidMount() {
    const { clientId } = this.props;

    Promise.all([
      crudActions.get(`v1/clients/lookups`),
      crudActions.get(`v1/clients/wallets/${clientId}`)
    ])
      .then(response => {
        const lookups = response[0];
        const wallets = response[1];
        this.setState({
          walletStatuses: lookups?.walletStatuses,
          cryptoExternalWallets: wallets?.cryptoWallets,
          // cryptoInternalWallets: response?.cryptoWallets,
          fiatExternalWallets: wallets?.fiatWallets,
          // fiatInternalWallets: response?.fiatWallets,
        });
      })
      .catch(err => {
        this.props.showAlert(true, "error", err?.message);
      })
      .finally(() => {
        this.setState({
          isLoadingWallet: false
        });
      });
  };

  onChangeWalletStatus = (value, prevValue, index) => {
    if (value !== prevValue.toUpperCase()) {
      this.setState({
        showPromptModal: true,
        editableWalletStatus: value,
        editableWalletIndex: index
      });
    }
  };

  handleConfirmPromptModal = () => {
    const {
      editableWalletId,
      editableWalletIndex,
      editableWalletStatus,
      editableWalletType
    } = this.state;

    const data = {
      "id": editableWalletId,
      status: editableWalletStatus
    };

    crudActions.put(
      `v1/clients/wallet/status-change`,
      data
    ).then(() => {
      const arrName = `${editableWalletType}ExternalWallets`;
      const wallets = this.state[arrName];
      wallets[editableWalletIndex].status = editableWalletStatus?.charAt(0) + editableWalletStatus?.slice(1).toLowerCase();
      this.setState({
        [arrName]: wallets,
        editableWalletId: null,
        editableWalletIndex: null,
        editableWalletStatus: '',
        editableWalletType: ''
      });
      
    }).catch(err => {
      this.props.showAlert(true, "error", err.message);
    }).finally(() => {
      this.setState({
        showPromptModal: false
      });
    });
  };
  
  handleClosePromptModal = () => {
    this.setState({
      showPromptModal: false
    });
  };

  addLog = (valueBefore, valueAfter, field, currency) => {
    const { logs } = this.state;
    const { clientId } = this.props;
  
    const type = "WALLET_UPDATE";
  
    const updatedLogs = addLogItem(logs, type, valueBefore, valueAfter, field, clientId, currency);
  
    this.setState({
      logs: updatedLogs
    });
  
    this.setState({
      logs
    });
  };

  getApproveLog = (clientId, currency) => {
    return addLogItem(
      [],
      "WALLET_APPROVE",
      false,
      true,
      "approve",
      clientId,
      {
        currency,
        userId: this.props.userId
      }
    );
  };

  doWalletAction = (action) => {
    const { clientId, companyId, isAgent } = this.props;
    const { currency } = this.state;

    const data = {
      companyId,
      id: clientId,
      currency,
      isAgent,
      changes: this.getApproveLog(clientId, currency)
    };
    crudActions.post(`v1/clients/wallet/${action}`, data)
      .then(() => {
        this.props.showAlert(true, "success", "Operation successful.");
      })
      .catch(err => {
        if (err && err.message) {
          this.props.showAlert(true, "error", err.message);
        }
      });
  };

  copyIcon = (data) => {
    return (
      <Icon
        name='content_copy'
        size={ 18 }
        onClick={ () => this.handleCopyTextClick(data) }
      />
    );
  };

  handleCopyTextClick = (text) => {
    navigator.clipboard.writeText(text);
    this.props.showMessage('Copied successfully!');
  };

  handleViewAddressClick = (address) => {
    this.setState({
      showModal: true,
      modalData: address
    });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false
    });
  };

  prepareTableData = (data, type) => {
    return data.map((elem, index) => {
      const accountNumber = elem.fields.find(field => field.name === 'accountNumber')?.value;
      const accNumberDisplay = accountNumber && accountNumber.length > 4 ? `...${accountNumber.slice(-4)}` : (accountNumber || '');
      const bankAddress = elem.fields.find(field => field.name === 'address')?.value;
      const routingNumber = elem.fields.find(field => field.name === 'routingNumber')?.value;
      const walletAddress = elem.fields.find(field => field.name === 'wallet')?.value;
      const walletAddressDisplay = walletAddress && walletAddress.length > 8 ? `${walletAddress.slice(0, 4)}...${walletAddress.slice(-4)}` : (walletAddress || '');
      return {
        ...elem,
        name: elem.fields.find(field => field.name === 'name')?.value,
        currency: elem.currency.split('_')[0],
        blockchain: elem.currency.split('_')[1],
        wallet: (
          <div className='with-icon'>
            {type === 'external' && (
              <>
                { this.copyIcon(walletAddress) }
              </>
            )}
            { walletAddressDisplay }
          </div>
        ),
        bankName: elem.fields.find(field => field.name === 'bankName')?.value,
        bankAddress: (
          <Icon
            name='visibility'
            size={ 18 }
            onClick={ () => this.handleViewAddressClick(bankAddress) }
          />
        ),
        accountNumber: (
          <div className='with-icon'>
            {type === 'external' && (
              <>
                { this.copyIcon(accountNumber) }
              </>
            )}
            { accNumberDisplay }
          </div>
        ),
        routingNumber: (
          <div className='with-icon'>
            {type === 'external' && (
              <>
                { this.copyIcon(routingNumber) }
              </>
            )}
            { routingNumber }
          </div>
        ),
        status: (
          <>
            {this.state.editableWalletId === elem.id ? (
              <Select
                value={ elem.status.toUpperCase() }
                clearable={ false }
                enableSearch={ false }
                options={ this.state.walletStatuses }
                onChange={ (e) => this.onChangeWalletStatus(e.value, elem.status, index) }
              />
            ) : elem.status }
          </>
        ),
        date: elem.submittedDate
      };
    });
  };

  onStatusDoubleClick = (wallet, column, type) => {
    if (!wallet || column.value !== 'status') return;
    this.setState({
      editableWalletId: wallet?.id,
      editableWalletType: type
    });
  };

  render() {
    const {
      clientId,
      loadingGeneralSettings
    } = this.props;

    const {
      cryptoExternalWallets,
      cryptoInternalWallets,
      fiatExternalWallets,
      fiatInternalWallets,
      isLoadingWallet,
      showPromptModal,
      showModal,
      modalData
    } = this.state;

    if (!clientId) return null;

    const loader = (
      <div style={ { width: "100%", height: "200px", display: "flex", alignItems: "center", justifyContent: "center" } }>
        <Spinner smallContainer={ true } />
      </div>
    );
    
    return (
      <>
        {loadingGeneralSettings ? (
          <>
            { loader }
          </>
        ) : (
          <div className='wallet-tables'>
            {isLoadingWallet ? (
              <>
                { loader }
              </>
            ) : (
              <>
                <div className='table-title'>
                Crypto Wallets - External
                </div>
                <Table
                  columns={ this.cryptoExternalColumns }
                  className='crypto-external'
                  data={ this.prepareTableData(cryptoExternalWallets, 'external') }
                  isStriped={ false }
                  headerColor={ "#223679" }
                  headerTextColor={ "#FFFFFF" }
                  withSort={ false }
                  useArrow={ false }
                  onDoubleClick={ (wallet, column) => this.onStatusDoubleClick(wallet, column, 'crypto') }
                />
                <div className='table-title'>
                Crypto Wallets - Internal
                </div>
                <Table
                  columns={ this.cryptoInternalColumns }
                  className='crypto-internal'
                  data={ this.prepareTableData(cryptoInternalWallets, 'internal') }
                  isStriped={ false }
                  headerColor={ "#223679" }
                  headerTextColor={ "#FFFFFF" }
                  withSort={ false }
                  useArrow={ false }
                />
                <div className='table-title'>
                Fiat Wallets - External
                </div>
                <Table
                  columns={ this.fiatExternalColumns }
                  className='fiat-external'
                  data={ this.prepareTableData(fiatExternalWallets, 'external') }
                  isStriped={ false }
                  headerColor={ "#223679" }
                  headerTextColor={ "#FFFFFF" }
                  withSort={ false }
                  useArrow={ false }
                  onDoubleClick={ (wallet, column) => this.onStatusDoubleClick(wallet, column, 'fiat') }
                />
                <div className='table-title'>
                Fiat Wallets - Internal
                </div>
                <Table
                  columns={ this.fiatInternalColumns }
                  className='fiat-internal'
                  data={ this.prepareTableData(fiatInternalWallets, 'internal') }
                  isStriped={ false }
                  headerColor={ "#223679" }
                  headerTextColor={ "#FFFFFF" }
                  withSort={ false }
                  useArrow={ false }
                />
              </>
            )}
          </div>
        )}

        <PromptModal
          title="Change wallet status"
          message="Do you really want to update wallet status?"
          handleConfirm={ this.handleConfirmPromptModal }
          handleClose={ this.handleClosePromptModal }
          isLoading={ false }
          showModal={ showPromptModal }
        />

        <Modal
          title="Bank Address"
          handleClose={ this.handleCloseModal }
          showModal={ showModal }
          modalType="text"
          data={ modalData }
          isLoading={ false }
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert,
    userId: state.authReducer.userId
  };
}

export default connect(mapStateToProps, actions)(WalletInfo);